module.exports = __webpack_public_path__ + "static/theBrandsBack-9fd1f900664c5a4bac3d675b097bd3dd.png";